import Chart, { useChart } from 'src/components/chart';

// ----------------------------------------------------------------------

type Props = {
  chartRef?:any;
  series: {
    name: string;
    data: number[];
  }[];
  chartOptionsObj?: any;
  height?: any;
};

export default function ChartColumnMultiple({chartRef, series, chartOptionsObj, height }: Props) {
  const chartOptions = useChart({
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
    },
    tooltip: {
      y: {
        formatter: (value: number) => `$ ${value} thousands`,
      },
    },
    plotOptions: { bar: { columnWidth: '36%' } },
    ...chartOptionsObj
  });

  return (
    <Chart ref={chartRef} dir="ltr" type="bar" series={series} options={chartOptions} width="100%" height={height ?? 320} />
  );
}
